import $ from 'jquery';

export default function($modal) {
  const $header = $('[data-header]');
  const $pre_header = $('[data-pre-header]');
  const $modal_overlay = $modal.find('[data-modal-overlay]');
  // This is seriously the coolest scrollbar detection ever...so simple
  const scrollbar_width = window.innerWidth - document.body.offsetWidth;
  let height_above;
  
  if ($pre_header.height() > 0 && theme.breakpoints.current !== 'mobile' && theme.breakpoints.current !== 'tablet') {
    height_above = $pre_header.height() + theme.breakpoints.gutters;
  } else {
    height_above = $header.height() + theme.breakpoints.gutters;
  }
  
  $modal.css('padding-top', height_above);
  $modal_overlay.css('left', scrollbar_width * -1);
  $pre_header.css('right', scrollbar_width);
  $header.css('right', scrollbar_width);
  $('main, [data-footer]').css('padding-right', scrollbar_width);
}